import React, { useState, useEffect } from 'react';
import { useTheme } from '../ThemeContext';
import styles from '../actions/Actions.module.css';
import TableContainer from '@mui/material/TableContainer';
import { DataGrid } from '@mui/x-data-grid';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';
import { LuMapPin } from "react-icons/lu";
//------------------------------------------------------------
//const config.ipAddress = '127.0.0.1'; // IP for developement local
//const config.ipAddress = '192.168.1.200'; // IP for deployment IIS
//------------------------------------------------------------

  

const Summary = () => {

    const { theme } = useTheme();
    const navigate = useNavigate();
    const [locationData, setLocationData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [selectedProgram, setSelectedProgram] = useState("");
    
    const levelMapping = {
        1: 'Basic Support Plan',
        2: 'Standard Support Plan',
        3: 'Premium Support Plan'
    };
    
    const columns = [
        { field: 'CompanyName', headerName: 'Company', width: 300 },
        { field: 'DivisionName', headerName: 'Division', width: 250 },
        { field: 'Region', headerName: 'Region', width: 100 },
        {
            field: 'OperationTypes',
            headerName: 'Operation Type',
            width: 220,
            renderCell: (params) => Array.isArray(params.value) ? params.value.join(', ') : (params.value || '')
        },
        {
            field: 'SiCamCustomer',
            headerName: 'Customer',
            width: 80,
            renderCell: (params) => {
                if (params.value === true || params.value === 1 || String(params.value).toLowerCase() === 'true') {
                    return 'Yes';
                }
                if (params.value === false || params.value === 0 || String(params.value).toLowerCase() === 'false') {
                    return 'No';
                }
                return '';
            }
        },
        { 
            field: 'SupportStatus', 
            headerName: 'Program Level', 
            width: 200,
            renderCell: (params) => levelMapping[params.value] || 'Unknown'
        },
        { 
            field: 'SupportStartDate', 
            headerName: 'Start Date', 
            width: 150,
            renderCell: (params) => params.value ? params.value.split('T')[0] : '' 
        },
        { 
            field: 'SupportEndDate', 
            headerName: 'End Date', 
            width: 100,
            renderCell: (params) => params.value ? params.value.split('T')[0] : '' 
        },
        {
            field: 'pointToMap',
            headerName: 'Point To Map',
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <IconButton
                    size="small"
                    color="primary"
                    onClick={() => navigate(`/maps?focusLocationId=${params.row.LocationID || params.row.locationid}`)}
                    title="Show on map"
                >
                    <LuMapPin size={18} />
                </IconButton>
            ),
        },
    ];
    
    const getRowId = (row) => row.locationid;
    
    const fetchData = async () => {
        try {
            const [summaryResponse, mapLocationResponse] = await Promise.all([
                fetch(`/api/`),
                fetch(`/api/map-locations`)
            ]);
            const result = await summaryResponse.json();
            const mapLocationResult = await mapLocationResponse.json();

            const mapLocationById = new Map(
                (Array.isArray(mapLocationResult) ? mapLocationResult : []).map((item) => [Number(item.LocationID), item])
            );

            const mergedLocationData = (result.locationTable || []).map((item) => {
                const mapLocation = mapLocationById.get(Number(item.LocationID || item.locationid)) || {};
                return {
                    ...item,
                    LocationID: item.LocationID || item.locationid,
                    Region: mapLocation.Region || item.Region || '',
                    OperationTypes: Array.isArray(mapLocation.OperationTypes) ? mapLocation.OperationTypes : [],
                    SiCamCustomer: mapLocation.SiCamCustomer ?? item.SiCamCustomer ?? '',
                };
            });

            setLocationData(mergedLocationData);
            setFilteredData(mergedLocationData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    
    useEffect(() => {
        fetchData();
    }, []);
    
    useEffect(() => {
        if (selectedProgram === "") {
            setFilteredData(locationData);
        } else {
            setFilteredData(locationData.filter(row => row.SupportStatus === parseInt(selectedProgram)));
        }
    }, [selectedProgram, locationData]);
    


  return (
    <>
      {/* ---------------------TABLE  --------------------------------   
      -------------------------TABLE  --------------------------------  
      -------------------------TABLE  --------------------------------     */}   
<aside className={`${styles.actions} ${styles[theme]}`}>
<Box className={`  ${styles[theme]}`} sx={{display: 'flex',flexDirection: 'row',width: '100%'}}>
               {/* BOX1 */}
              <Box className={` ${styles[theme]}`} sx={{m:1,width:'100%'}}>
                <Paper elevation={1}> 
                
                <Box className={`${styles.box} ${styles[theme]}`}
                    sx={{
                      display: 'flex', // Use flex display
                      justifyContent: 'space-between', // Center the content horizontally
                      alignItems: 'center', // Align items vertically in the center
                      paddingTop: '8px', // Optional padding at the top
                      paddingBottom: '0px', // Optional padding at the bottom
                    }}
                  >
                    

                    {/* Typography for "Actions" text */}
                    <Box sx={{
                      display: 'flex',
                       }}>
                    <Typography 
                      sx={{
                        fontFamily: 'DM Serif Display, serif',
                        fontWeight: '400',
                        fontStyle: 'normal',
                        textAlign: 'left',
                        flexGrow: 1, // Allows the text to grow and push the icon to the right
                        paddingLeft: '10px'
                      }}
                      variant="h6"
                      gutterBottom
                    >
                     SUMMARY
                    </Typography>
                    <Typography 
                      sx={{
                        paddingLeft: '20px',
                        paddingTop: '2px',
                        textAlign: 'left',
                      }}
                      variant="overline"
                      
                    >
                     <u>Support Program Overview By Location</u>
                    </Typography>
                    <FormControl sx={{ width: '250px', marginLeft: '320px', paddingBottom: '5px', height:'50px' }}>
                                <InputLabel sx={{ 
                                            
                                            top: '-5px',
                                            
                                        }} className={`${styles.select} ${styles[theme]}`} id="program-label">Filter By Program Level</InputLabel>
                                <Select className={`${styles.select} ${styles[theme]}`}
                                    style={{ height: '45px' }}
                                    
                                    labelId="program-label"
                                    value={selectedProgram}
                                    onChange={(event) => setSelectedProgram(event.target.value)}>
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    <MenuItem value="1">Basic Support Plan</MenuItem>
                                    <MenuItem value="2">Standard Support Plan</MenuItem>
                                    <MenuItem value="3">Premium Support Plan</MenuItem>
                                </Select>
                            </FormControl>
                    </Box>
                    <Box sx={{
                      display: 'flex',
                       }}>
                    
                    
                    
                     </Box>
                  </Box>
               
                </Paper> 
                 {/* TABLE DATA* */}
                  {/* TABLE DATA*/}
                  {/* TABLE DATA**/}


                  <style>
                    {`
                      .light-theme .my-datagrid .MuiDataGrid-root .MuiDataGrid-cell,
                     .light-theme .my-datagrid .MuiDataGrid-columnHeaders {
                            background-color:  #F8FAFC   !important; /* Light theme header background */
                            color: #000 !important; /* Light theme text color */
                              font-weight: bold; /* Makes the font bold */
                        }
                  
                      .light-theme .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }
                      /* Dark theme styles */
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaders {
                                background-color: #0B192C !important; /* Dark theme header background */
                                color: #0B192C !important; /* Dark theme text color */
                                 font-weight: bold; /* Makes the font bold */
                            }
                      .dark-theme .MuiDataGrid-root {
                        border-color: #2c2c2b; /* Dark theme border color */
                      }
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaders,
                      .dark-theme .my-datagrid .MuiDataGrid-cell,
                      .dark-theme .my-datagrid .MuiTablePagination-root,
                      .dark-theme .my-datagrid .MuiDataGrid-withBorderColor,
                      .dark-theme .my-datagrid .MuiDataGrid-root,
                      .dark-theme .MuiTypography-root,
                      .dark-theme .MuiButtonBase-root.MuiIconButton-root,
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaderTitle {
                        background-color: ##000; /* Dark theme background color */
                        color: #D8D8D8; /* Dark theme text color */
                        border-color: #2c2c2b;
                         /* Makes the font bold */
                      }
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiTablePagination-caption,
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiTablePagination-toolbar,
                      .dark-theme .my-datagrid .MuiTablePagination-root .MuiIconButton-label,
                      .dark-theme .my-datagrid .MuiButtonBase-root.MuiIconButton-root.Mui-disabled
                      {
                        color: #ffffff; /* Dark theme pagination text color */
                       
                      .dark-theme .my-datagrid .MuiDataGrid-columnHeaderTitleContainer {
                        background-color: inherit; /* Ensure the background color fills the whole header */
                      }

                   
                  
                      
                      
                      
                    `}
                    </style>

                <TableContainer  className={`${styles[theme]} ${theme === 'light' ? 'light-theme' : 'dark-theme'}`}  style={{ height: '530px', overflowY: 'auto' }}  >
                {/* <div style={{ height: '85vh', width: '100%' }}> */}
                  <DataGrid
                  className="my-datagrid"
                  rows={filteredData}
                  columns={columns}
                  getRowId={getRowId}
                  initialState={{ pagination: { paginationModel: { page: 0, pageSize: 15 } } }}
                  pageSizeOptions={[10, 15]}
                  rowHeight={30}
                  headerHeight={35}
                    //checkboxSelection
                  />
                </TableContainer>
              </Box>
            </Box> 
            </aside>
    </>
  )
}

export default Summary
